import React from 'react';
import { motion } from 'framer-motion';
import { bookInfo } from '../../data/bookData';
import { FiShoppingCart, FiGlobe } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const HeroSection = () => {
  return (
    <section 
      className="relative min-h-screen flex items-center pt-20 pb-16 overflow-hidden bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url('https://media-manager-c.questera.ai/greta-media/ae05bbc051fb17176d2c348bf77438a7a494626431a725f22ebe70ac4579d949c16512ea83019a888cf26e0e50680ce7/images/aW1hZ2UvanBlZw==/d69337167f381c4000f603f860745692.jpeg')` }}
    >
      {/* Background Overlays for Text Readability */}
      <div className="absolute inset-0 z-0 bg-black/40"></div>
      <div className="absolute inset-0 z-0 bg-gradient-to-r from-brand-dark/95 via-brand-dark/60 to-transparent"></div>
      <div className="absolute inset-0 z-0 bg-gradient-to-t from-brand-dark via-transparent to-black/40"></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center">
          {/* Text Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="order-2 lg:order-1 text-center lg:text-left"
          >
            <p className="text-brand-accent font-semibold tracking-widest uppercase mb-4 text-sm md:text-base drop-shadow-md">
              New Sci-Fi Release
            </p>
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-display font-bold text-white leading-tight mb-6 text-glow">
              THE QUANTUM <br className="hidden md:block"/> AWAKENING
            </h1>
            <p className="text-xl md:text-2xl text-gray-200 font-light mb-8 drop-shadow-md">
              {bookInfo.subtitle}
            </p>
            <p className="text-lg text-gray-300 mb-10 max-w-xl mx-auto lg:mx-0 drop-shadow-md">
              By <span className="text-white font-medium">{bookInfo.author}</span>
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" id="buy">
              <div className="relative group">
                <button className="w-full sm:w-auto px-8 py-4 bg-brand-accent text-brand-dark rounded-lg font-bold text-lg flex items-center justify-center gap-3 hover:bg-brand-accentHover transition-all duration-300 transform group-hover:-translate-y-1 shadow-lg">
                  <SafeIcon icon={FiShoppingCart} /> Buy on Amazon
                </button>
                <div className="absolute top-full left-0 mt-2 w-full bg-brand-surface border border-white/10 rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-20 flex flex-col overflow-hidden">
                  <a href={bookInfo.links.amazon.kindle} target="_blank" rel="noreferrer" className="px-4 py-3 hover:bg-white/5 text-gray-200 text-sm border-b border-white/5">Kindle Edition</a>
                  <a href={bookInfo.links.amazon.paperback} target="_blank" rel="noreferrer" className="px-4 py-3 hover:bg-white/5 text-gray-200 text-sm border-b border-white/5">Paperback</a>
                  <a href={bookInfo.links.amazon.hardcover} target="_blank" rel="noreferrer" className="px-4 py-3 hover:bg-white/5 text-gray-200 text-sm">Hardcover</a>
                </div>
              </div>
              
              <div className="relative group">
                <button className="w-full sm:w-auto px-8 py-4 bg-black/40 backdrop-blur-sm text-white border border-white/30 rounded-lg font-bold text-lg flex items-center justify-center gap-3 hover:bg-black/60 transition-all duration-300 shadow-lg">
                  <SafeIcon icon={FiGlobe} /> Author Website
                </button>
                <div className="absolute top-full left-0 mt-2 w-full bg-brand-surface border border-white/10 rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-20 flex flex-col overflow-hidden">
                  <a href={bookInfo.links.website.en} target="_blank" rel="noreferrer" className="px-4 py-3 hover:bg-white/5 text-gray-200 text-sm border-b border-white/5">English (EN)</a>
                  <a href={bookInfo.links.website.ro} target="_blank" rel="noreferrer" className="px-4 py-3 hover:bg-white/5 text-gray-200 text-sm">Romanian (RO)</a>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Book Cover 3D Effect */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9, rotateY: 15 }}
            animate={{ opacity: 1, scale: 1, rotateY: 0 }}
            transition={{ duration: 1, delay: 0.2 }}
            className="order-1 lg:order-2 flex justify-center lg:justify-end perspective-1000"
          >
            <div className="relative w-64 md:w-80 lg:w-96 group">
              <div className="absolute inset-0 bg-brand-accent/30 blur-[80px] rounded-full transform group-hover:scale-110 transition-transform duration-700"></div>
              <img
                src={bookInfo.coverImage}
                alt="The Quantum Awakening Book Cover"
                className="relative z-10 w-full h-auto rounded-md shadow-2xl shadow-black/80 transform transition-transform duration-500 hover:rotate-y-[-5deg] hover:scale-[1.02] border border-white/10"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;